import React, { createContext, useContext, useMemo, useState } from "react";
import ar from "./ar.json";
import en from "./en.json";

const dicts = { ar, en };

const I18nContext = createContext(null);

function resolve(obj, path) {
  return path.split(".").reduce((acc, key) => (acc == null ? acc : acc[key]), obj);
}

export function I18nProvider({ children }) {
  const [lang, setLang] = useState("ar");

  const value = useMemo(() => {
    const dict = dicts[lang] || dicts.ar;
    const t = (key, fallback) => {
      const val = resolve(dict, key);
      return val == null ? (fallback != null ? fallback : key) : val;
    };
    return { lang, setLang, t };
  }, [lang]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
}
